import {
    getCachedTableDataSlice,
    getCachedTableResultSelector,
} from 'src/hooks/common-data-service/cached-table';

import {userSearchResultStateSelector} from './user-search-result-state.slice';

import type {
    CachedTableCacheSelector,
    CachedTableDataSelector,
} from 'src/hooks/common-data-service/cached-table/typedef';
import type {UserSearchCriteria} from 'src/openapi/admin/models/UserSearchCriteria';
import type {UserSearchFiltering} from 'src/openapi/admin/models/UserSearchFiltering';
import type {UserSortField} from 'src/openapi/admin/models/UserSortField';

export const userSearchResultGroupsSlice = getCachedTableDataSlice<
    Record<string, string>,
    UserSearchCriteria,
    UserSortField,
    UserSearchFiltering
>('userSearchResultGroups');

export const userSearchResultGroupsActions = userSearchResultGroupsSlice.actions;

const userSearchResultGroupsCacheSelector: CachedTableCacheSelector<Record<string, string>>
    = state => state.userSearchResult.groups.cache;
export const userSearchResultGroupsDataSelector: CachedTableDataSelector<Record<string, string>>
    = state => state.userSearchResult.groups;
export const userSearchResultGroupsResultSelector = getCachedTableResultSelector(
    userSearchResultGroupsCacheSelector,
    userSearchResultStateSelector,
);
